export class AccountNrAttribute {
    private static mobileReg = new RegExp(/^\d{10}$/);
    public static hasError(value: string): boolean {
        if (!this.mobileReg.test(value)) {
            return true;
        }
        return false;
    }

    public static getErrorMessage(): string {
        return "Indtast et gyldigt konto.nr.";
    }
}